<template>
  <FilterLayout v-model="advance_filter">
    <AddressSection
      :province="filterState.address.province"
      :amphur="filterState.address.amphur"
      :tumbol="filterState.address.tumbol"
      :village="filterState.address.village"
      @update:province="updateAddress($event, 'province')"
      @update:amphur="updateAddress($event, 'amphur')"
      @update:tumbol="updateAddress($event, 'tumbol')"
      @update:village="updateAddress($event, 'village')"
      parentComponent="family"
      key="family"
      :disabledProvince="getAllowActionByCurrRole('disabled-province-search')"
    />

    <!-- advance -->
    <section data-test="filter-advance" v-show="advance_filter">
      <hr class="border-theme-33 mt-3" />

      <PersonInfoSection
        class="mt-2"
        :national_id="filterState.national_id"
        :full_name="filterState.full_name"
        @update:national_id="handelNationalIdChange"
        @update:full_name="handelFullNameChange"
      />
      <FamilyCharacteristicsSection v-model="filterState.family_types" />
      <ProblemSection class="mt-3" v-model="filterState.problems" />
      <FamilyMemberRangeSection v-model="filterState.member_range" />
      <VolunteerSection v-model="filterState.volunteer" />
    </section>
    <div class="flex justify-end mt-3">
      <button class="btn btn-outline-secondary mr-2" @click="resetState">
        ล้าง
      </button>
      <button class="btn btn-primary" @click="sendToStore">
        ค้นหา
      </button>
    </div>
  </FilterLayout>
</template>

<script setup>
import AddressSection from "./component/AddressSection.vue";
import FamilyCharacteristicsSection from "./component/FamilyCharacteristicsSection.vue";
import ProblemSection from "./component/ProblemSection.vue";
import FamilyMemberRangeSection from "./component/FamilyMemberRangeSection.vue";
import VolunteerSection from "./component/VolunteerSection.vue";
import FilterLayout from "./layout/index.vue";
import PersonInfoSection from "./component/PersonInfoSection.vue";
import { reactive, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { getAllowActionByCurrRole } from "@/utils/get-roles"
// START: declare data

const INIT_FILTER_VALUE = {
  address: {
    amphur: null,
    province: null,
    tumbol: null,
    village: null,
  },
  family_types: [],
  full_name: null,
  member_range: {
    start: null,
    end: null,
  },
  national_id: null,
  problems: [],
  volunteer: null,
  cm_uid: null
};

const store = useStore();
const filterState = ref(JSON.parse(JSON.stringify(INIT_FILTER_VALUE)));
const advance_filter = ref(false);

onMounted(() => {
  filterState.value = JSON.parse(
    JSON.stringify(store.getters["familyFilter/getAllFilter"])
  );
  if(localStorage.getItem("volunteerData")){
    filterState.volunteer = JSON.parse(localStorage.getItem("volunteerData"))
  }
  advance_filter.value = filterState.value.advance_filter
});

const handelNationalIdChange = (evt) => {
  filterState.value.national_id = evt;
};
const handelFullNameChange = (evt) => {
  filterState.value.full_name = evt;
};
const resetState = () => {
  const initFilter = JSON.parse(JSON.stringify(INIT_FILTER_VALUE));
  initFilter.address.province = filterState.value.address.province;
  filterState.value = initFilter;
};
const sendToStore = () => {
  let result = filterState.value;
  result.advance_filter = advance_filter.value;
  if(localStorage.getItem("volunteerData")){
    result.volunteer = JSON.parse(localStorage.getItem("volunteerData"))
  }
  store.dispatch("familyFilter/setStore", JSON.parse(JSON.stringify(result)));
};
const updateAddress = (evt, key) => {
  filterState.value.address[key] = evt;
};
</script>
